import {
    ConfluenceTemplateDetailsRelayPageTemplate,
    ConfluenceTemplateDetailsRelayPageTemplateProps
} from "@/templates/software/confluence/templates/confluence-templates-page/src/relay/contentful-relay/confluence-template-details-contentful-relay-page.template";

export const ConfluenceTemplateDetailsRelayPage = ({
    queryRef
}: ConfluenceTemplateDetailsRelayPageTemplateProps) => {
    return <ConfluenceTemplateDetailsRelayPageTemplate queryRef={queryRef} />;
};
